import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storagePromise } from "configuration";

const PROFILE_COMPRESSION = {
  maxSizeMB: 0.5,
  maxWidthOrHeight: 400,
  useWebWorker: true,
  fileType: "image/jpeg",
};

/**
 * Upload a profile image to users/{uid}/profile.
 * Overwrites any existing image at that path — no cleanup needed.
 * @param {string} uid - Firebase Auth UID
 * @param {File} file - Image file selected by the user
 * @returns {Promise<string>} Public download URL
 */
export async function uploadProfileImage(uid: string, file: File): Promise<string> {
  const imageCompression = (await import("browser-image-compression")).default;
  const compressed = await imageCompression(file, PROFILE_COMPRESSION);

  const storage = await storagePromise;
  const profileRef = ref(storage, `users/${uid}/profile`);
  const snapshot = await uploadBytes(profileRef, compressed);
  return await getDownloadURL(snapshot.ref);
}
